import {
  SELLERFORM_FETCHITEM_LOAD,
  SELLERFORM_FETCHITEM_SUCCEED,
  SELLERFORM_FETCHITEM_FAIL,
  SELLERFORM_EDITFORM_CHANGE,
  SELLERFORM_ENTER_RESET,
  SELLERFORM_CREATEITEM_LOAD,
  SELLERFORM_CREATEITEM_SUCCEED,
  SELLERFORM_CREATEITEM_FAIL,
  SELLERFORM_EDITITEM_LOAD,
  SELLERFORM_EDITITEM_SUCCEED,
  SELLERFORM_EDITITEM_FAIL,
  SELLERFORM_DELETEITEM_LOAD,
  SELLERFORM_DELETEITEM_SUCCEED,
  SELLERFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case SELLERFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case SELLERFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case SELLERFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case SELLERFORM_ENTER_RESET:
      return {}
    case SELLERFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case SELLERFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case SELLERFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case SELLERFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case SELLERFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case SELLERFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case SELLERFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case SELLERFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case SELLERFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case SELLERFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/sellerForm.js